import styled from 'styled-components';

export const PanelSubtitle = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
`;
